import React, { createContext, useState, useEffect, useContext } from 'react';

// 创建 ServiceContext 上下文
export const ServiceContext = createContext();

// 提供上下文的组件
export const ServiceProvider = ({ children }) => {
  // 使用 sessionStorage 存储表号和服务模式
  const [tableNumber, setTableNumber] = useState(()=>{
    const sessionData = sessionStorage.getItem('tableNumber');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('tableNumber','');
        return '';
    }
  });
  const [storeName, setStoreName] = useState(()=>{
    const sessionData = sessionStorage.getItem('storeName');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('storeName','');
        return '';
    }
  });
  const [serviceMode, setServiceMode] = useState(()=>{
    const sessionData = sessionStorage.getItem('serviceMode');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('serviceMode','Dine-in');
        return 'Dine-in';
    }
  });

  const [storeId, setStoreId] = useState(()=>{
    const sessionData = sessionStorage.getItem('storeId');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('storeId','');
        return '';
    }
  });
  const [language, setLanguage] = useState(()=>{
    const sessionData = sessionStorage.getItem('language');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('language','');
        return '';
    }
  });
  const [uiLanguage, setUiLanguage] = useState(()=>{
    const sessionData = sessionStorage.getItem('uiLanguage');
    if (sessionData) {
        return sessionData;
    } else {
        // 如果 sessionStorage 中没有数据，返回一个空数组
        sessionStorage.setItem('uiLanguage','');
        return '';
    }
  });
  const [dineInGuestCount, setDineInGuestCount] = useState(()=>{
    const sessionData = sessionStorage.getItem('dineInGuestCount');
    if (sessionData) {
        return Number(sessionData) || null;
    } else {
        sessionStorage.setItem('dineInGuestCount','');
        return null;
    }
  });

  // 将数据同步到 sessionStorage
  useEffect(() => {
    sessionStorage.setItem('tableNumber', tableNumber);
    sessionStorage.setItem('serviceMode', serviceMode);
  
    sessionStorage.setItem('storeName', storeName);
    sessionStorage.setItem('storeId', storeId);
    sessionStorage.setItem('language', language);
    sessionStorage.setItem('uiLanguage', uiLanguage);
    sessionStorage.setItem('dineInGuestCount', dineInGuestCount || '');


  }, [tableNumber, serviceMode,storeName, storeId, language, uiLanguage, dineInGuestCount]);

  // 从 sessionStorage 中读取初始值
  useEffect(() => {
    const storedTableNumber = sessionStorage.getItem('tableNumber');
    const storedServiceMode = sessionStorage.getItem('serviceMode');
    const storedStoreName = sessionStorage.getItem('storeName');
    const storedStoreId = sessionStorage.getItem('storeId');
    const storedLanguage = sessionStorage.getItem('language');
    const storedUiLanguage = sessionStorage.getItem('uiLanguage');
    const storedDineInGuestCount = sessionStorage.getItem('dineInGuestCount');


    if (storedTableNumber) {
     
      setTableNumber(storedTableNumber);
    }

    if (storedServiceMode) {
      setServiceMode(storedServiceMode);
    }
    if (storedStoreName) {
    
      setStoreName(storedStoreName);
    }
    if (storedStoreId) {
    
      setStoreId(storedStoreId);

    }
    if (storedLanguage) {
    
      setLanguage(storedLanguage);

    }
    if (storedUiLanguage) {
    
      setUiLanguage(storedUiLanguage);

    }
    if (storedDineInGuestCount) {
    
      setDineInGuestCount(Number(storedDineInGuestCount) || null);

    }

  }, []);

  // 提供上下文的值
  const contextValue = {
    tableNumber,
    setTableNumber,
    serviceMode,
    setServiceMode,
    storeName,
    setStoreName,
    storeId,
    setStoreId,
    language,
    setLanguage,
    uiLanguage,
    setUiLanguage,
    dineInGuestCount,
    setDineInGuestCount
  };

  return (
    <ServiceContext.Provider value={contextValue}>
      {children}
    </ServiceContext.Provider>
  );
};
